import { Helmet } from "react-helmet";

interface SEOHeadProps {
  title: string;
  description: string;
  path: string;
  noindex?: boolean;
  /** Absolute or root-relative path to OG image */
  ogImage?: string;
}

const SITE = "https://www.marktognolirealty.com";
const DEFAULT_OG = `${SITE}/og-image.jpg`;

const SEOHead = ({ title, description, path, noindex, ogImage }: SEOHeadProps) => {
  const url = `${SITE}${path}`;
  const image = ogImage
    ? ogImage.startsWith("http")
      ? ogImage
      : `${SITE}${ogImage}`
    : DEFAULT_OG;

  return (
    <Helmet>
      <title>{title}</title>
      <meta name="description" content={description} />
      <link rel="canonical" href={url} />
      {noindex && <meta name="robots" content="noindex, nofollow" />}

      {/* Open Graph */}
      <meta property="og:type" content="website" />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={url} />
      <meta property="og:image" content={image} />
      <meta property="og:site_name" content="Mark Tognoli Realty" />

      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={image} />
    </Helmet>
  );
};

export default SEOHead;
